/* eslint-disable class-methods-use-this */
import { DataBarCellRenderer } from '@deephaven/grid';
import IrisGridCellRendererUtils from "./IrisGridCellRendererUtils.js";
class IrisGridDataBarCellRenderer extends DataBarCellRenderer {
  drawTreeMarker(context, state, columnX, rowY, treeBox, color, isExpanded) {
    IrisGridCellRendererUtils.drawTreeMarker(context, state, columnX, rowY, treeBox, color, isExpanded);
  }
}
export default IrisGridDataBarCellRenderer;
//# sourceMappingURL=IrisGridDataBarCellRenderer.js.map